import { render, staticRenderFns } from "./36.vue?vue&type=template&id=13b5e3c4&scoped=true&"
import script from "./36.vue?vue&type=script&lang=js&"
export * from "./36.vue?vue&type=script&lang=js&"
import style0 from "./36.vue?vue&type=style&index=0&id=13b5e3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5e3c4",
  null
  
)

export default component.exports